/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Permission_Name_Templatesroles_WriteInputs */

const en_enum_permission_name_templatesroles_write = /** @type {(inputs: Enum_Permission_Name_Templatesroles_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Templatesroles Write`)
};

const de_enum_permission_name_templatesroles_write = /** @type {(inputs: Enum_Permission_Name_Templatesroles_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Templatesroles Write`)
};

/**
* | output |
* | --- |
* | "Templatesroles Write" |
*
* @param {Enum_Permission_Name_Templatesroles_WriteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_permission_name_templatesroles_write = /** @type {((inputs?: Enum_Permission_Name_Templatesroles_WriteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Permission_Name_Templatesroles_WriteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_permission_name_templatesroles_write(inputs)
	return de_enum_permission_name_templatesroles_write(inputs)
});